import { render, staticRenderFns } from "./32.vue?vue&type=template&id=efa70f0e&scoped=true&"
var script = {}
import style0 from "./32.vue?vue&type=style&index=0&id=efa70f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa70f0e",
  null
  
)

export default component.exports